import { CustomerPaymentMethod } from '@@types'
import classNames from 'classnames'
import { useTranslation } from 'react-i18next'
import { ReactSVG } from 'react-svg'

import { useModalStore } from '@features/modal'
import { useManagePaymentMethods } from '@features/payment/hooks/useManagePaymentMethods'
import DeleteCardModal from '@features/payment/ui/delete-card-modal/DeleteCardModal'


import useSBPBanks from '@shared/hooks/useSBPBanks'
import { getPaymentMethodLogo } from '@shared/lib/paymentMethodLogos'
import Radio from '@shared/ui/radio'

import styles from './styles.module.scss'



export default function CardItem ({
  data,
}: {
  data: CustomerPaymentMethod;
}) {
  const { t } = useTranslation('personal')
  const { handleDefault } = useManagePaymentMethods()
  const { openModal } = useModalStore()
  const { staticBanks, loading: loadingBanks } = useSBPBanks()

  // Определяем иконку и текст в зависимости от типа платежного метода
  let iconSrc = '/icons/card.svg'
  let displayText = `${t('payment.card')} ****${data?.last}`
  let additionalIcon: string | null = null

  if (data?.type === 'sbp') {
    // Для СБП находим банк по schema (формат: bank100000000111)
    const bank = staticBanks.find((b) => b.schema === `bank${data.last}`)
    
    if (bank) {
      iconSrc = bank.logo
      displayText = bank.name
    }
    else if (!loadingBanks && data.last) {
      // Если банк не найден, но загрузка завершена, показываем ID банка
      displayText = `СБП (${data.last})`
    }
    else {
      displayText = 'СБП'
    }
    
    additionalIcon = getPaymentMethodLogo('sbp')
  }
  else if (data?.type === 'card' && data?.card) {
    // Для карт используем логотип платежной системы
    iconSrc = getPaymentMethodLogo(data.card)
    displayText = `${t('payment.card')} ****${data.last}`
  }

  return (
    <div className={styles.root} key={data?.id as string}>
      <Radio
        onChange={() => handleDefault(data?.id as string)}
        checked={!!data?.isDefault}
      />
      <div className={styles.root__iconContainer}>
        {data?.type === 'sbp' && staticBanks.find((b) => b.schema === `bank${data.last}`) ? (
          <img
            className={classNames(styles.root__icon)}
            src={iconSrc}
            alt={displayText}
          />
        ) : (
          <ReactSVG
            className={classNames(styles.root__icon)}
            wrapper="span"
            src={iconSrc}
          />
        )}
        {additionalIcon && (
          <img
            className={classNames(styles.root__icon, styles['root__icon--additional'])}
            src={additionalIcon}
            alt="СБП"
          />
        )}
      </div>
      <p className={styles.root__text}>
        {displayText}
      </p>
      <ReactSVG
        className={classNames(styles.root__icon, styles['root__icon--delete'])}
        wrapper="span"
        onClick={() => {
          openModal('deleteCard', <DeleteCardModal id={data?.id as string} />, {
            title: t('payment.delete-card'),
          })
        }}
        src="/icons/delete.svg"
      />
    </div>
  )
}
